import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from '@shared/shared.module';

import { UnauthorisedComponent } from './unauthorised.component';

const appRoutes: Routes = [
  {
    path: 'unauthorised',
    component: UnauthorisedComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(appRoutes)
  ],
  declarations: [UnauthorisedComponent]
})
export class UnauthorisedModule { }
